<div id="fontLoader" style="position: absolute; visibility:hidden"></div>
<div #component><template #playercontainer></template></div>
<div name="htmlLayer" style="pointer-events: none"></div>
<div *ngIf="showF11" id="fs" style="position: absolute; top: 50px" @fadeIn @fadeOut>
  <div id="sq">
    <h1 id="sl">press <span id="sa">F11</span> to enter full screen / audio</h1>
  </div>
</div>





